import { ref, computed } from "vue";
import { useDialog } from "primevue/usedialog";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import UnauthorizedAccess from "@/components/UnauthorizedAccess.vue";

export interface UnauthorizedAccessData {
    status?: number;
    message?: string;
}

export const useUnauthorizedAccessDialog = () => {
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();
    const isVisible = computed(() => Boolean(dialogRef.value?.visible));

    const open = (data: UnauthorizedAccessData = {}) => {
        // Close existing dialog if it's open
        if (dialogRef.value && dialogRef.value.visible) {
            dialogRef.value.close();
        }

        dialogRef.value = dialog.open(UnauthorizedAccess, {
            props: {
                style: {
                    width: "600px",
                },
                modal: true,
                closable: false,
                draggable: false,
                closeOnEscape: false,
            },
            data,
        });

        return dialogRef.value;
    };

    return {
        open,
        isVisible,
    };
};
